/* tslint:disable */
/* eslint-disable */
/**
 * gremiumhub
 * A platform for digital applications, approvals and discussions.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: denis.lugowski@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AnnexRowChangeDto } from './AnnexRowChangeDto';
import {
    AnnexRowChangeDtoFromJSON,
    AnnexRowChangeDtoFromJSONTyped,
    AnnexRowChangeDtoToJSON,
    AnnexRowChangeDtoToJSONTyped,
} from './AnnexRowChangeDto';
import type { ChangeKind } from './ChangeKind';
import {
    ChangeKindFromJSON,
    ChangeKindFromJSONTyped,
    ChangeKindToJSON,
    ChangeKindToJSONTyped,
} from './ChangeKind';

/**
 * 
 * @export
 * @interface AnnexChangeDto
 */
export interface AnnexChangeDto {
    /**
     * 
     * @type {number}
     * @memberof AnnexChangeDto
     */
    number: number;
    /**
     * 
     * @type {string}
     * @memberof AnnexChangeDto
     */
    title: string;
    /**
     * ADDED or REMOVED when only one of the two versions has the annex, absent when both have it.
     * @type {ChangeKind}
     * @memberof AnnexChangeDto
     */
    kind?: ChangeKind | null;
    /**
     * 
     * @type {Array<AnnexRowChangeDto>}
     * @memberof AnnexChangeDto
     */
    rows: Array<AnnexRowChangeDto>;
}



/**
 * Check if a given object implements the AnnexChangeDto interface.
 */
export function instanceOfAnnexChangeDto(value: object): value is AnnexChangeDto {
    if (!('number' in value) || value['number'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('rows' in value) || value['rows'] === undefined) return false;
    return true;
}

export function AnnexChangeDtoFromJSON(json: any): AnnexChangeDto {
    return AnnexChangeDtoFromJSONTyped(json, false);
}

export function AnnexChangeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AnnexChangeDto {
    if (json == null) {
        return json;
    }
    return {
        
        'number': json['number'],
        'title': json['title'],
        'kind': json['kind'] == null ? undefined : ChangeKindFromJSON(json['kind']),
        'rows': ((json['rows'] as Array<any>).map(AnnexRowChangeDtoFromJSON)),
    };
}

export function AnnexChangeDtoToJSON(json: any): AnnexChangeDto {
    return AnnexChangeDtoToJSONTyped(json, false);
}

export function AnnexChangeDtoToJSONTyped(value?: AnnexChangeDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'number': value['number'],
        'title': value['title'],
        'kind': ChangeKindToJSON(value['kind']),
        'rows': ((value['rows'] as Array<any>).map(AnnexRowChangeDtoToJSON)),
    };
}

